import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { MediaQuery as MQ } from '../../../shared/media-query';
import DatePicker from '../date-picker';
import Pill from './shared/pill';
import { truncate } from '../../../shared/util';
import dayjs from 'dayjs';
import _ from 'underscore';
import TextLinks from './shared/daily-text-links';

class Component extends BaseComponent {
    constructor() {
        super();
        this.state = { width: window.innerWidth };
    }

    componentDidMount() {
        const date = this.props.date || dayjs().format('YYYY-MM-DD');
        this.date = date;
        this.props.requireNumber(date);

        this.props.trackEvent([
            'Daily Nav',
            `${this.props.logged_in ? 'LI' : 'LO'} Impression`,
            'Number of the Day:Daily Text Links',
        ]);
    }

    /* eslint-disable complexity */
    shouldComponentUpdate(nextProps) {
        if (nextProps.logged_in != this.props.logged_in) {
            if (!nextProps.logged_in && this.props.base_url.match(/vip/)) { //user logs out on VIP page
                document.location.href = this.props.base_url.replace(/\/vip/, '');
                return false;
            } else if (
                nextProps.logged_in
                &&
                nextProps.user.subscriptions
                &&
                nextProps.user.subscriptions.vip
                &&
                !this.props.base_url.match(/vip/)
            ) { //user logs in on non-VIP page
                document.location.href = `/vip${this.props.base_url}`;
                return false;
            } else if (!nextProps.logged_in) {
                document.location.reload();
            }

            this.props.getAutologin();

            return true;
        }

        if (nextProps.autologin != this.props.autologin) {
            return true;
        }

        if (nextProps.number != this.props.number) {
            return true;
        }

        return false;
    }
    /* eslint-enable complexity */

    render({ base_url, number, logged_in }) {
        const action = `${this.props.logged_in ? 'LI' : 'LO'} Click`;
        const label = 'Text - Learn More About Numerology';
        const vip = this.props.base_url.match(/vip/);

        if (number && !vip) {
            const plabel = logged_in ? 'Learn More About Numerology' : 'Get Your Daily Number';
            this.props.trackEvent(['Daily Number', 'LI Impression', 'Number of the Day: Of The Day Pills']);

            return (
                <daily-number base_url={base_url} date={this.date}>
                    <row className='is-visible-mobile'>
                        {this.renderDateLinks()}
                    </row>
                    <row>
                        <column className='is-4 is-5-mobile'>
                            <img
                                src={`https://gfx.tarot.com/images/numerology/daily/${number.personal_number}.jpg`}
                                alt='Daily Number'
                                width='250'
                                height='300'
                            />
                        </column>
                        <column className='is-8 is-7-mobile'>
                            <row className='is-hidden-mobile has-margin-30-top'>
                                {this.renderDateLinks()}
                            </row>
                            <h1 className='has-margin-20-top has-margin-30-bottom'>Number of the Day</h1>
                            <Pill
                                label={plabel}
                                link='/numerology'
                                handleClick={() => this.props.trackEvent([
                                    'Daily Nav',
                                    action,
                                    `Daily Number: ${plabel}`,
                                ])}
                            />
                        </column>
                    </row>
                    <row>
                        <column className='is-12'>
                            <p className='has-margin-10-top'>
                                <b>{dayjs(this.date).format('M.D.YY')}: </b>
                                <span dangerouslySetInnerHTML={{__html: truncate(number.content, 325)}} />
                                <a
                                    href={this.renderNumeroLink()}
                                    onClick={() => this.props.trackEvent(['Daily Number', action, 'Read More'])}
                                >
                                    Read More
                                </a>
                            </p>
                        </column>
                    </row>
                </daily-number>
            );
        } else if (number && vip) {
            return (
                <daily-number base_url={base_url} date={this.date}>
                    {this.renderVIP()}
                </daily-number>
            );
        } else if (logged_in) {
            return <daily-number base_url={base_url} date={this.date} />;
        }

        this.props.trackEvent(['Daily Number', 'LO Impression', label]);

        return (
            <daily-number base_url={base_url} date={this.date}>
                <row className='has-margin-15-left'>
                    <column
                        className='is-4 is-5-mobile has-text-center has-padding-30-right
                        has-padding-20-right-mobile has-padding-10-top'
                    >
                        <img
                            src='https://gfx.tarot.com/images/daily-pages/daily-icons/number.svg'
                            height='249'
                            width='225'
                            alt='Daily Number'
                            className='number-unknown'
                        />
                        <div className='daily-links has-margin-10-top has-text-center is-hidden-mobile'>
                            <a
                                href='/numerology'
                                onClick={() => this.props.trackEvent(['Daily Number', action, label])}
                            >
                                Learn More<br />About Numerology
                            </a>
                        </div>
                    </column>
                    <column className='is-8 is-7-mobile'>
                        <h1 className='has-margin-20-bottom'>Number of the Day</h1>
                        <p className='has-margin-15-bottom'>Looking for your Number of the Day?</p>
                        <div className='is-hidden-mobile'>
                            {this.renderCTA()}
                        </div>
                    </column>
                </row>
                <row className='has-margin-30-bottom has-margin-15-left has-margin-15-right'>
                    <column className='is-visible-mobile has-text-center'>
                        {this.renderCTA()}
                        <a
                            href='/numerology'
                            className='is-block has-margin-20-top'
                            onClick={() => this.props.trackEvent(['Daily Number', action, label])}
                        >
                            Learn More About Numerology
                        </a>
                    </column>
                </row>
            </daily-number>
        );
    }

    renderVIP = () => {
        if (MQ.isMobile()) {
            return (
                <daily-number-mobile date={this.date} base_url={this.props.base_url}>
                    <DatePicker
                        url={`${this.props.base_url || '/daily-number'}/:date`}
                        page='number'
                        mindate={dayjs().subtract(90, 'day').format('YYYY-MM-DD')}
                        maxdate={dayjs().add(2, 'day').format('YYYY-MM-DD')}
                        date={dayjs(this.date, 'YYYY-MM-DD').format('YYYY-MM-DD')}
                        autosubmit='true'
                    />
                    <h1>Number of the Day</h1>
                    <div className={`today-number nod-${this.props.number.personal_number}`} />
                    <div>
                        <h2>Your Daily Number: {this.props.number.number}</h2>
                        <h5>{this.props.number.title}</h5>
                        <p className='has-margin-10-top'>
                            <b>{dayjs(this.date).format('M.D.YY')}: </b>
                            <span dangerouslySetInnerHTML={{__html: truncate(this.props.number.content, 325)}} />
                            <a
                                href={this.renderNumeroLink()}
                                onClick={this.trackClick}
                            >
                                Read More
                            </a>
                        </p>
                    </div>
                </daily-number-mobile>
            );
        }

        return (
            <daily-number-nonmobile date={this.date}>
                <div className='daily-number'>
                    <img
                        src={`https://gfx.tarot.com/images/numerology/daily/${this.props.number.personal_number}.jpg`}
                        alt='Daily Number'
                    />
                </div>
                <row>
                    <column className='is-1'>
                        <DatePicker
                            url={`${this.props.base_url || '/daily-number'}/:date`}
                            page='number'
                            mindate={dayjs().subtract(90, 'day').format('YYYY-MM-DD')}
                            maxdate={dayjs().add(2, 'day').format('YYYY-MM-DD')}
                            date={dayjs(this.date, 'YYYY-MM-DD').format('YYYY-MM-DD')}
                            autosubmit='true'
                        />
                    </column>
                    <column className='is-11'>
                        <TextLinks
                            date={this.date}
                            base_url={this.props.base_url || '/daily-number'}
                        />
                    </column>
                </row>
                <h1>Number of<br />the Day</h1>
                <div className='daily-links'>
                    <a href='/numerology'>Learn More About Numerology</a>
                </div>
                <br />
                <p className='has-margin-10-top'>
                    <b>{dayjs(this.date).format('M.D.YY')}: </b>
                    <span dangerouslySetInnerHTML={{__html: truncate(this.props.number.content, 325)}} />
                    <a
                        href={this.renderNumeroLink()}
                        onClick={this.trackClick}
                    >
                            Read More
                    </a>
                </p>
            </daily-number-nonmobile>
        );
    }

    renderCTA = () => {
        return [
            <p>
                Create your profile to receive a number that's personalized to YOU every day!
            </p>,
            <a href='#login-signup' className='button button-pink-alternate is-pill has-margin-10-top'>
                GET YOUR DAILY NUMBER
            </a>,
        ];
    }

    renderDateLinks = () => {
        if (this.props.logged_in) {
            const date = dayjs(this.date, 'YYYY-MM-DD').format('YYYY-MM-DD');

            return [
                <column className='is-1'>
                    <DatePicker
                        url={`${this.props.base_url || '/daily-number'}/:date`}
                        page='number'
                        mindate={dayjs().subtract(90, 'day').format('YYYY-MM-DD')}
                        maxdate={dayjs().add(2, 'day').format('YYYY-MM-DD')}
                        date={date}
                        autosubmit='true'
                    />
                </column>,
                <column className='is-11'>
                    <TextLinks
                        date={date}
                        base_url={this.props.base_url || '/daily-number'}
                    />
                </column>,
            ];
        }

        return null;
    }

    renderNumeroLink = () => {
        const domain = _.contains(['stage', 'dev'], this.props.environment)
            ? 'https://stage.numerology.com/'
            : 'https://numerology.com';
        const args = this.props.autologin
            ? `?today=${this.date}&m=${this.props.autologin.m}&mauto=${this.props.autologin.mauto}`
            : `?today=${this.date}`;

        return `${domain}/daily-number${args}`;
    }
}

const mapStateToProps = (state) => ({
    number: state.number,
    logged_in: state.user && state.user.logged_in,
    user: state.user,
    environment: state.environment,
    autologin: state.autologin,
});

const mapDispatchToProps = (dispatch) => ({
    requireNumber: (date) => dispatch({ type: 'number:required', payload: date }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    getAutologin: () => dispatch({ type: 'autologin:get' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
